var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"route-wrap"},_vm._l((_vm.routeInfo),function(item){return _c('li',{key:item.icons,on:{"click":function($event){return _vm.goToPage(item.url, item.type)}}},[_c('div',{staticClass:"route-icon-wrap"},[_c('eui-icon',{attrs:{"icon":item.icons,"font-size":"24px"}})],1),_c('p',[_vm._v(_vm._s(item.iconName))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }